import * as React from 'react';
import { ICountdownRendererProps } from 'react-countdown-now';
import styled from 'styled-components';

interface ICountdownTextProps {
  text: {
    DaysText: string;
    HoursText: string;
    MinutesText: string;
    SecondsText: string;
  };
}

type Props = ICountdownTextProps & ICountdownRendererProps;

export const CountdownRenderer: React.SFC<Props> = props => (
  <Container>
    <span>{props.days} &nbsp; &nbsp;</span> {props.text.DaysText}
    <span>{props.hours}</span>{' '} {props.text.HoursText}
    <span>{props.minutes}</span> {props.text.MinutesText}{' '}
    <span>{props.seconds}</span> {props.text.SecondsText}
  </Container>
);

const Container = styled.div`
  display: flex;
  font-size: 19px;
  justify-content: center;
  text-transform: uppercase;
  font-weight: 300;
  margin-bottom: 5px;
  flex-wrap: wrap;
  & > span {
    display: inline-block;
    width: 40px;
    font-weight: bold;
    font-weight: 700;
    text-align: center;
  }
`;

export default CountdownRenderer;



// WEBPACK FOOTER //
// ./src/components/CountdownRenderer/CountdownRenderer.tsx